import React, { useState } from "react";
import { Button, Form, Modal, ModalTitle } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ButtonLoading, FormInput } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { FormDirty } from "go-form/components/FormDirty";
import { partnerApi } from "../../../../../../../services/Api/Partner/partnerApi";
import { OrganizationApi } from "../../../../../../../services/Api/types";

interface Props {
	partnerId: number;
	onHide: (data?: OrganizationApi) => void;
}

interface AddPartnerUserApi {
	email: string;
}

const AddPartnerUserModal = ({ partnerId, onHide }: Props) => {
	const [loading, setLoading] = useState(false);
	const form = useForm<AddPartnerUserApi>({
		defaultValues: {
			email: "",
		},
	});
	const { addSuccessFlash, addFlash } = useFlash();
	const {
		formState: { errors },
		setError,
		register,
		handleSubmit,
		formState,
	} = form;
	const { t } = useTranslation("admin");

	const onSubmit = handleSubmit(async (data) => {
		setLoading(true);
		try {
			const resp = await partnerApi.addUserByPartner(partnerId, data.email);
			addSuccessFlash(t("common.flash.saved", { ns: "lib" }));
			onHide(resp);
		} catch (e) {
			handleError.form(e, setError, addFlash);
		}
		setLoading(false);
	});

	return (
		<Modal show onHide={onHide}>
			<FormDirty formState={formState} onSubmit={onSubmit}>
				<Modal.Header>
					<ModalTitle>{t("modules.user.header.new.title")}</ModalTitle>
				</Modal.Header>
				<Modal.Body>
					<FormInput name={"email"} errors={errors} register={register} label={t("lib:common.word.email")} />
				</Modal.Body>
			</FormDirty>
			<Modal.Footer>
				<Form.Group className="form-group">
					<ButtonLoading loading={loading} type={"submit"} onClick={onSubmit}>
						{t("common.action.save", { ns: "lib" })}
					</ButtonLoading>
					<Button variant="light" type="button" onClick={() => onHide()}>
						{t("common.action.cancel", { ns: "lib" })}
					</Button>
				</Form.Group>
			</Modal.Footer>
		</Modal>
	);
};
export default AddPartnerUserModal;
